import {useContext} from "react";
import {FeedbackContextValue} from "./FeedbackContextValue";
import {FeedbackContext} from "./FeedbackContext";

export function useFeedback(): FeedbackContextValue {
  return useContext(FeedbackContext);
}
